module.exports = __webpack_public_path__ + "img/PT171.0d485469.png";